import { render, staticRenderFns } from "./MasterDataSettings.vue?vue&type=template&id=44a949ad&scoped=true"
import script from "./MasterDataSettings.vue?vue&type=script&lang=js"
export * from "./MasterDataSettings.vue?vue&type=script&lang=js"
import style0 from "./MasterDataSettings.vue?vue&type=style&index=0&id=44a949ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a949ad",
  null
  
)

export default component.exports